module.exports = __webpack_public_path__ + "img/zuo.dd5c9984.png";